import { render } from "./CardsStack.vue?vue&type=template&id=ab6ecfb2&scoped=true"
import script from "./CardsStack.vue?vue&type=script&lang=js"
export * from "./CardsStack.vue?vue&type=script&lang=js"

import "./CardsStack.vue?vue&type=style&index=0&id=ab6ecfb2&lang=scss&scoped=true"

import exportComponent from "D:\\dev\\vuejs\\nafn\\nafn.urmull.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6ecfb2"]])

export default __exports__